import { validateSDL } from "graphql/validation/validate";


export const handleSubmit = ({
                                 updateCustomer,
                                 history,
                                 customerToEdit,
                                 tablePaginationSize,
                                 customerId,
                             }) => values => {
    const updatedData = updateCustomer({
        variables: {
            customerInput: {
                ...values,
            },
            customerId,
        },
    });

    return updatedData.then(result => {
        const customer = result.data ? result.data.updateCustomer : null;
        if (customer) {
            history.goBack();
        }
    });
};
